export default __webpack_public_path__ + "static/media/ic_panama.071b3e94.svg";